<template>
    <div class="product">
        <div class="product-header">
            <img style="width: 100%" src="../../assets/imgs/product/product-bg.png" alt="">
        </div>
        <div class="course-content" >
            <a href="https://qitianzhen.tmall.com/" class="link-box" style="margin-left: 169px;cursor: pointer;"><img src="../../assets/imgs/product/tm.jpg"/><span>天猫旗舰店</span></a>
            <a href="https://qitianzhen.jd.com/" class="link-box" style="cursor: pointer;"><img src="../../assets/imgs/product/jd.jpg"/><span>京东旗舰店</span></a>
            <div class="link-box" style="margin-right: 169px;"><img src="../../assets/imgs/product/yx.jpg"/><span>七田真优选</span></div>
        </div>
        <div class="course-content" style="margin-top: 50px;">
            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">经典明星产品</button>
                </div>
            </div>
            <ul class="list-text classic-product-list">
                <li>
                    <div class="classic-product-pic">
                        <img src="../../assets/imgs/product/product-1.png" alt="">
                    </div>
                    <div class="classic-product-name">百科闪卡</div>
                    <div class="classic-product-intro">First Picture Flash Cards</div>
                    <div class="classic-product-age">6个月-6岁/1800张/A5</div>
                    <ul class="classic-product-des">
                        <li>八国语言,国际小公民</li>
                        <li>手绘图案,激发想象力</li>
                        <li>多种玩法,提升记忆力</li>
                    </ul>
                </li>

                <li>
                    <div class="classic-product-pic">
                        <img src="../../assets/imgs/product/product-2.png" alt="">
                    </div>
                    <div class="classic-product-name">文字卡</div>
                    <div class="classic-product-intro">First Words Flash Cards</div>
                    <div class="classic-product-age">2-6岁/1800张/A5</div>
                    <ul class="classic-product-des">
                        <li>中英双语</li>
                        <li>图文对应，百科闪卡好搭档</li>
                    </ul>
                </li>

                <li>
                    <div class="classic-product-pic">
                        <img src="../../assets/imgs/product/product-88.png" style="height:238px" alt="">
                    </div>
                    <div class="classic-product-name">点卡</div>
                    <div class="classic-product-intro">Magic Dots Cards</div>
                    <div class="classic-product-age">6个月-6岁/663张/A5</div>
                    <ul class="classic-product-des">
                        <li>63天训练计划</li>
                        <li>培养数感</li>
                    </ul>
                </li>
            </ul>

            <div v-for="(item,i) in productList" :key="i" style="margin-bottom: 20px">
                <div class="content-item">
                    <div class="content-title">
                        <button class="page-btn" v-text="item.title"></button>
                    </div>
                </div>
                <ul class="sk-list">
                    <li v-for="(tag,index) in item.list" :key="index">
                        <div class="sk-pic"><img :src="tag.video_pic" alt=""></div>
                        <div class="sk-name" v-text="tag.title"></div>
                        <div class="fit-age" v-text="tag.simple_description"></div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                productList: ''
            }
        },
        created(){
            let loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.$http.get('https://q.qitianzhen.cn/api/product_list').then((res) => {
                console.log(res.data.list);
                this.productList = res.data.list;
                loading.close();
            });
        }
    }
</script>
<style lang="less">
    .product{
        .content-item{
            border-top: 1px solid #FBC300;
        }
        .page-btn{
            background: #FBC300;
        }
        .link-box{
            display: inline-block;
            width: 150px;
            height: 200px;
            color: #303030;
            font-size: 15px;
            text-align: center;
            line-height: 2;
            text-decoration: none;
            font-weight: 600;
            margin: 50px 50px 0px 50px;
            // cursor: pointer;
            img{
                width: 150px;
                height: 150px;
            }
        }
        .classic-product-list{
            display: flex;
            justify-content: space-between;
            .classic-product-name{
                font-weight: 600;
                font-size: 26px;
                color: #F6AB00;
                line-height: 1.4;
            }
            .classic-product-intro{
                font-family: Light;
                font-size: 14px;
                color: #F6AB00;
                line-height: 1.2;
            }
            .classic-product-age{
                display: inline-block;
                height: 24px;
                line-height: 24px;
                padding: 0 20px;
                margin-top: 15px;
                background: #898989;
                color: #fff;
                border-radius: 20px;
                font-size: 14px;
            }
            .classic-product-des{
                margin-top: 5px;
                font-family: Light;
                font-size: 14px;
                line-height: 22px;
                color: #A7A7A7;
            }
        }
        .sk-list{
            display: flex;
            flex-wrap: wrap;
            li{
                width: 25%;
                margin-bottom: 15px;
            }
            .sk-pic{
                img{
                    display: block;
                    margin: 0 auto;
                    width: 135px;
                    height: 135px;
                }
            }
            .sk-name{
                margin-top: 10px;
                font-weight: 600;
                font-size: 18px;
                color: #FBC300;
                text-align: center;
            }
            .fit-age{
                font-weight: 600;
                font-size: 15px;
                color: #898989;
                text-align: center;
            }
        }
        .list-text{
            margin: 30px 0;
            color: #6A6767;
            font-size: 16px;
            font-family: Light;
            li{
                img{
                    margin-right: 15px;
                }
            }
        }
    }
</style>
